import React from 'react';

export default function LandingPage(){
    return(
        <>
            <h1>Welcome to TAP</h1>
            <p>This is the Landing page of the web app TAP!!</p>
        </>
    );
}